import {
  ChevronLeftIcon,
  ChevronRightIcon,
  Tooltip,
  useEffect,
  useSidebarStore,
} from "@";
import { memo } from "react";

const ToggleSmallShow = () => {
  const { toggleSidebarSize, initSidebarSize } = useSidebarStore();

  useEffect(() => {
    initSidebarSize();
  }, [initSidebarSize]);

  const handleKeyPress = (event) => {
    if (event.key === "]") {
      toggleSidebarSize();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [toggleSidebarSize]);

  return (
    <>
      <button
        type="button"
        id="themeToggleBtn"
        onClick={toggleSidebarSize}
        data-tooltip-target="toggleSidebar"
        data-tooltip-placement="right"
        aria-label="تبديل حجم الشريط الجانبي"
        className="group absolute top-14 border  dark:border-gray-700 rounded-full -start-3 z-50 hidden h-7 w-7 items-center justify-center bg-white dark:bg-gray-900 text-purple-500 transition-all duration-200 hover:bg-purple-100 hover:text-purple-900 hover:ring-white/30 dark:hover:bg-gray-700 dark:hover:text-purple-300 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60 lg:flex"
      >
        <ChevronLeftIcon
          className="arrow-end-circle hidden h-4 w-4"
          strokeWidth={2.5}
        />
        <ChevronRightIcon
          className="arrow-start-circle h-4 w-4"
          strokeWidth={2.5}
        />
      </button>
      <Tooltip
        className="dark:bg-gray-600"
        title="تبديل حجم الشريط الجانبي"
        hint="["
        id="toggleSidebar"
      />
    </>
  );
};

export default memo(ToggleSmallShow);
